import {Button, HStack, Text} from '@chakra-ui/react';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';

interface Props {
  defaultValue: number;
  onChange: (value: number) => void;
  isSmallSize?: boolean;
  isDisabled?: boolean;
  min?: number;
  max?: number;
}

export const Counter: FC<Props> = ({defaultValue, onChange, isSmallSize, isDisabled, max}) => {
  const changeCountHandler = (value: number) => {
    if (value >= 0) {
      onChange(value);
    }
  };

  const fullSizeBtn = {
    w: ['40px', '50px'],
    h: ['40px', '50px'],
  };

  const smallSizeBtn = {
    w: '40px',
    h: '40px',
  };

  return (
    <HStack fontWeight="600" fontSize="16px" justifyContent="center">
      <Button
        onClick={(e) => {
          e.stopPropagation();
          changeCountHandler(Number(defaultValue - 1));
        }}
        variant="counter"
        p="0"
        sx={isSmallSize ? smallSizeBtn : fullSizeBtn}
      >
        <ImageUI src="/icons/minus.svg" alt="Minus" />
      </Button>
      <Text as="span" w="40px" textAlign="center">
        {defaultValue}
      </Text>
      <Button
        disabled={isDisabled || max === defaultValue}
        onClick={(e) => {
          e.stopPropagation();
          changeCountHandler(Number(defaultValue + 1));
        }}
        variant="counter"
        p="0"
        sx={isSmallSize ? smallSizeBtn : fullSizeBtn}
      >
        <ImageUI src="/icons/plus.svg" alt="Plus" />
      </Button>
    </HStack>
  );
};
